import Loader from "react-loader-spinner";
import React from "react";

export default function index() {
  const mode = localStorage.getItem("mode");
  return (
    <>
      {mode === "dark" ? (
        <div
          style={{
            backgroundColor: "black",
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader type="Circles" color="#4717F6" height={100} width={100} />
        </div>
      ) : (
        <div
        style={{
          backgroundColor: "white",
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader type="Circles" color="#4717F6" height={100} width={100} />
      </div>
      )}
    </>
  );
}
